import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=5fb4a4a6&scoped=true&"
import script from "./StatusIcon.vue?vue&type=script&lang=js&"
export * from "./StatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./StatusIcon.vue?vue&type=style&index=0&id=5fb4a4a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb4a4a6",
  null
  
)

export default component.exports